import { AxiosPromise } from "axios";
import {
  DesignDto,
  LocationResourceApi,
  MenuFolderDto,
} from "../generated/dashboard-client";
import { dashboardApiConfig, ops } from "./config";

const api = new LocationResourceApi(dashboardApiConfig);

const LocationsApi = {
  getLocationDesigns(id: number): AxiosPromise<DesignDto[]> {
    return api.getLocationDesigns(id, ops());
  },
  getLocationFolders(id: number): AxiosPromise<MenuFolderDto[]> {
    return api.getLocationFolders(id, ops());
  },
  createLocationFolder(id: number, name: string): AxiosPromise<MenuFolderDto> {
    return api.createLocationFolder(id, name, undefined, undefined, ops());
  },
  renameFolder(id: number, name: string): AxiosPromise<void> {
    return api.renameFolder(id, { name }, ops());
  },
  deleteFolder(id: number): AxiosPromise<void> {
    return api.deleteFolder(id, ops());
  },
};

export default LocationsApi;
